import { OzSkeletonBox, SKELETON_BOX_SIZE } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

export function SkeletonLoading (): ReactElement {
    return (
        <div>
            <OzSkeletonBox size={SKELETON_BOX_SIZE.SIZE_2} />
            <OzSkeletonBox className='mt-2 mb-1' size={SKELETON_BOX_SIZE.SIZE_8} />
        </div>
    );
}
